import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'
import { ROUTE_LOGIN, ROUTE_REGISTER, ROUTE_LOGIN_SUCCESS, ROUTE_REGISTER_SUCCESS } from '../constants'
import Card from '../card'
import LoginForm from '../form/login'
import RegisterForm from '../form/register'
import LoginSuccess from '../form/loginSuccess'
import RegisterSuccess from '../form/registerSuccess'
import { UserProvider } from '../context/UserContext'

class Routes extends Component {
  render () {
    return (
      <div className='pt-12 h-screen overflow-auto'>
        <Card>
          <UserProvider>
            <Switch>
              <Route path={ROUTE_LOGIN_SUCCESS} exact component={LoginSuccess}></Route>
              <Route path={ROUTE_REGISTER_SUCCESS} exact component={RegisterSuccess}></Route>

              <Route path={ROUTE_LOGIN} exact component={LoginForm}></Route>
              <Route path={ROUTE_REGISTER} exact component={RegisterForm}></Route>
            </Switch>
          </UserProvider>
        </Card>
      </div>
    )
  }
}

export default Routes